import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FacilitatorService } from '../services/facilitator.service';
import { MasterDataService } from '../services/masterdata.service';
import { UserRolesService } from '../services/user-roles.service';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgMultiselectDropdownDirective } from '../directives/ng-multiselect-dropdown.directive';
import { Modal } from 'bootstrap';
declare var bootstrap: any;

@Component({
    selector: 'app-facilitator-search',
    templateUrl: './facilitator-search.component.html',
    styleUrls: ['./facilitator-search.component.css'],
    providers: [FacilitatorService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FacilitatorSearchComponent implements OnInit, OnDestroy {
  private subscription: Subject<void> = new Subject<void>();
  dropdownSettings: IDropdownSettings;
  CitydropdownSettings: IDropdownSettings;
  selectedServicedropdownSettings: IDropdownSettings;
  selectedSectordropdownSettings: IDropdownSettings;
  DeliveryModeldropdownSettings: IDropdownSettings;
  FacilitateddropdownSettings: IDropdownSettings;
  masterData: any;
  countryList: Array<any>;
  stateList: Array<any>;
  cityList: Array<any>;
  functionList: Array<any>;
  serviceList: Array<any>;
  jobLevelList: Array<any>;
  industryList: Array<any>;
  sectorList: Array<any>;
  certificationLevelList: Array<any>;
  contentAreaList: Array<any>;
  topicList: Array<any>;

  experinceLevelRange: Array<any> = [
    { sessionsfacilitatedID: 1, SessionsRange: 'Novice' },
    { sessionsfacilitatedID: 2, SessionsRange: 'Experienced' },
    { sessionsfacilitatedID: 3, SessionsRange: 'Very Experienced' },
  ];

  selectedName: string = '';
  selectedCountry: any = [];
  selectedState: any = [];
  selectedCity: any = [];
  selectedFunction: any = [];
  selectedService: any = [];
  selectedJobLevel: any = [];
  selectedIndustry: any = [];
  selectedSector: any = [];
  selectedCertificationLevel: number = 0;
  selectedContentArea: any = null;
  selectedTopic: any = null;
  selectedExperienceLevelRange: any = [];
  isMDRData: boolean = false;

  settings: any;
  showTable: boolean = false;
  showPopUp: boolean = false;
  editFacilitatorsDetails: any;
  masterDataForEdit: any;
  roleId: number;
  sampleColumns: any;
  sampleData: any;
  allowCheckbox: boolean;
  allowSelectAllCheckbox: boolean;
  iseventRegistered: boolean;
  allowPagination: boolean;
  isClientSidePagination: boolean;
  totalRecords: number = 0;
  pageSize: number = 50;
  emailslist: string;
  pageNo: number = 1;
  isRequestorAvailabilityDisabled: boolean = true;
  showLoader: boolean = false;
  emailListAcrossPages: any;
  previousPage: number;
  checkuncheckflag: boolean = false;
  gridNoResultMsg: string =
    'Search results not found. Please refine your search.';
  sortColumn: any = 'LastName';
  sortOrder: any = 'ASC';
  disableButtons: boolean = false;
  pageNoToSave: number;
  searchGridHeight: any;
  searchAreaFields: boolean = true;
  seaerchAreaDownArrow: boolean = false;
  seaerchAreaUpArrow: boolean = false;
  onSearchClicked: boolean = true;
  flagObject: boolean = true;
  reloadUsingQueryParams: boolean = false;
  selectedDeliveryModel: any = []; // As per US: 2564047
  deliveryModelList: Array<any>; //As per US: 2564047
  updatedStateDataList: any = []; //for placeholder 30may
  updatedCityDataList: any = []; //for placeholder 30may
  updatedFunctionDataList: any = []; //for placeholder 30may
  updatedServiceDataList: any = []; //for placeholder 30may
  updatedIndustryDataList: any = []; //for placeholder 30may
  updatedSectorDataList: any = []; //for placeholder 30may
  facilitatorSearchForm: FormGroup;
  userType: string = null;
  isAdvanceSearch: boolean = false;
  showExportBtn: boolean = false;
  exportPayload: any;
  countryPlaceholder: string = 'Select';
  statePlaceholder: string = 'Select';
  cityPlaceholder: string = 'Select';
  disableState: boolean = true;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private masterDataService: MasterDataService,
    private facilitatorService: FacilitatorService,
    public userRoleService: UserRolesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.deliveryModelList = [];
  }

  @ViewChild('headerHeight', { static: true })
  headerHeight: ElementRef;
  @ViewChild('searchFieldsHeight', { static: true })
  searchFieldsHeight: ElementRef;
  // view child for ng-multiselect-dropdown
  @ViewChild('child', { static: true })
  selectChild: NgMultiselectDropdownDirective;
  @ViewChild('child1', { static: true })
  selectChild1: NgMultiselectDropdownDirective;
  @ViewChild('child2', { static: true })
  selectChild2: NgMultiselectDropdownDirective;
  @ViewChild('child3', { static: true })
  selectChild3: NgMultiselectDropdownDirective;
  @ViewChild('child5', { static: true })
  selectChild5: NgMultiselectDropdownDirective;
  @ViewChild('child6', { static: true })
  selectChild6: NgMultiselectDropdownDirective;

  ngAfterViewInit() {
    this.searchGridHeightSet();
  }
  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }
  onResize(event) {
    this.searchGridHeightSet();
  }

  searchGridHeightSet() {
    setTimeout(() => {
      const SearchFildsHeight =
        this.searchFieldsHeight.nativeElement.offsetHeight;
      const screenHeight = window.innerHeight;
      const totalDedVal = SearchFildsHeight - 50;
      return (this.searchGridHeight = screenHeight - totalDedVal + 'px');
    }, 300);
  }

  searchAreaExpand() {
    if (this.isAdvanceSearch) {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('show');
          element.classList.remove('collapse');
        }
        // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
        //   show: true
        //   });
        //   $("#accordion .accordion1").collapse("show");
      }, 100);
    } else {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('collapse');
          element.classList.remove('show');
        }
        // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
        //   show: true
        //   });
        //  $("#accordion .accordion1").collapse("hide");
      }, 100);
    }
    this.searchAreaFields = true;
    this.seaerchAreaDownArrow = false;
    this.seaerchAreaUpArrow = true;
    this.searchGridHeightSet();
  }

  searchAreaCollapse() {
    this.searchAreaFields = false;
    this.seaerchAreaDownArrow = true;
    this.seaerchAreaUpArrow = false;
    this.searchGridHeightSet();
  }

  clearLevelSearch(e, type) {
    if (type === 'country') {
      this.selectedCountry = [];
      this.selectedState = [];
      this.selectedCity = [];
      this.selectedFunction = [];
      this.selectedService = [];
      this.selectedIndustry = [];
      this.selectedSector = [];
    }
    if (type === 'state') {
      this.selectedState = [];
      this.selectedCity = [];
    }
    if (type === 'city') {
      this.selectedCity = [];
    }
    if (type === 'function') {
      this.selectedFunction = [];
      this.selectedService = [];
    }
    if (type === 'serviceArea') {
      this.selectedService = [];
    }
    if (type === 'level') {
      this.selectedJobLevel = [];
    }
    if (type === 'industry') {
      this.selectedIndustry = [];
      this.selectedSector = [];
    }
    if (type === 'sector') {
      this.selectedSector = [];
    }
    if (type === 'experienceLevel') {
      this.selectedExperienceLevelRange = [];
    }
    if (type === 'DeliveryModel') {
      this.selectedDeliveryModel = [];
    }
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ID',
      textField: 'Name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.facilitatorSearchForm = this.fb.group({
      CountryID: [this.selectedCountry],
      StateID: [this.selectedState],
      CityID: [this.selectedCity],
      FunctionID: [this.selectedFunction],
      ServiceID: [this.selectedService],
      LevelID: [this.selectedJobLevel],
      IndustryID: [this.selectedIndustry],
      SectorID: [this.selectedSector],
      DeloitteSessionID: [this.selectedExperienceLevelRange],
      deliveryModelID: [this.selectedDeliveryModel],
      contentAreaID: [this.selectedContentArea],
      topicID: [this.selectedTopic ?? 0],
    });

    this.CitydropdownSettings = {
      singleSelection: false,
      idField: 'CityID',
      textField: 'CityName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.selectedServicedropdownSettings = {
      singleSelection: false,
      idField: 'ServiceAreaID',
      textField: 'ServiceAreaName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.selectedSectordropdownSettings = {
      singleSelection: false,
      idField: 'SectorID',
      textField: 'SectorName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.DeliveryModeldropdownSettings = {
      singleSelection: false,
      idField: 'SessionFormatID',
      textField: 'SessionFormatName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.FacilitateddropdownSettings = {
      singleSelection: false,
      idField: 'SessionsRange',
      textField: 'SessionsRange',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
    };
    this.emailListAcrossPages = [];
    this.previousPage = 1;
    this.masterDataService
      .getMasterDataDetails()
      .pipe(takeUntil(this.subscription))
      .subscribe((masterData) => {
        if (masterData) {
          this.masterData = masterData;
          this.intialLoading();
          this.reloadWithData();
        }
      });
    // commented this code as we are not using ng2-smart-table right now the code.
    // this.tableData.onChanged().subscribe((change) => {
    //   switch (change.action) {
    //     case "page":
    //       break;
    //     case "sort":
    //       break;
    //   }
    // });

    this.checkDisability();
  }

  intialLoading() {
  this.showLoader = true;
  this.countryList = this.masterData['Countries']
      ? this.masterData['Countries'].filter(
        (country) => country.ID != 266)
      : [];
    this.stateList = this.masterData['States'] ? this.masterData['States'] : [];
    this.cityList = this.masterData['Cities'] ? this.masterData['Cities'] : [];
    this.functionList = this.masterData['ServiceFunctions']
      ? this.masterData['ServiceFunctions']
      : [];
    this.serviceList = this.masterData['ServiceAreas']
      ? this.masterData['ServiceAreas']
      : [];
    this.jobLevelList = this.masterData['JobLevels']
      ? this.masterData['JobLevels']
      : [];
    this.industryList = this.masterData['Industries']
      ? this.masterData['Industries']
      : [];
    this.sectorList = this.masterData['Sectors']
      ? this.masterData['Sectors']
      : [];
    this.certificationLevelList = this.masterData['Certificationlevels']
      ? this.masterData['Certificationlevels']
      : [];
    this.contentAreaList = this.masterData['ContentArea']
      ? this.masterData['ContentArea']
      : [];
    this.topicList = this.masterData['Topic']
      ? JSON.parse(JSON.stringify(this.masterData['Topic'])).sort((a, b) =>
        a.TopicName.localeCompare(b.TopicName)
      )
      : [];

    let initialSessionFormatList = [];
    initialSessionFormatList = this.masterData['SessionFormat']
      ? this.masterData['SessionFormat']
      : [];
    if (initialSessionFormatList.length > 0) {
      this.deliveryModelList = initialSessionFormatList.filter(
        (data: any) =>
          data['SessionFormatID'] === 1 ||
          data['SessionFormatID'] === 2 ||
          data['SessionFormatID'] === 6
      );
    }
    setTimeout(() => {
      this.reloadByQueryParams();
    }, 2000);
  }

  onCountrySelect(data) {
    // 1 June pramod
    if (this.selectedCountry !== null && this.selectedCountry.length > 0) {
      if (this.selectedCountry[0]?.Name !== undefined) {
        const selectedcountry = [];
        this.selectedCountry.forEach((country) =>
          selectedcountry.push(country.ID)
        );
        this.selectedCountry = selectedcountry;
      }
    }

    if (data['selectAll'] !== undefined) {
      const country = Number(data['item']['id']);
      const isChecked = data['isChecked'];
      if (country !== 0 && isChecked === true) {
        this.selectedCountry.push(country);
      } else {
        this.selectedCountry.forEach((item, index) => {
          if (item === country) this.selectedCountry.splice(index, 1);
        });
      }
      this.isMDRData =
        country === 23 || country === 259 || country === 265 ? true : false;
      if (Number(country) && this.selectedCountry.length > 0) {
        this.updateStatesBasedOnCountry(Number(country), isChecked);
        this.updateCitiesBasedOnCountry(Number(country));
        this.updateServiceFunctionBasedOnCountry(Number(country));
        this.updateServiceAreaBasedOnCountry(Number(country));
        this.updateIndustriesBasedOnCountry(Number(country));
        this.updateSectorsBasedOnCountry(Number(country));
      } else {
        this.selectedState = [];
        this.selectedCity = [];
        this.selectedFunction = [];
        this.selectedService = [];
        this.selectedIndustry = [];
        this.selectedSector = [];
      }
    } else if (data.length === 0) {
      this.selectedCountry = [];
      this.selectedState = [];
      this.selectedCity = [];
      this.selectedFunction = [];
      this.selectedService = [];
      this.selectedIndustry = [];
      this.selectedSector = [];

      //Added below two line to resolve bug: 2708531
      const tempData = [];
      this.onStateSelect(tempData);
    } else {
      this.selectedCountry = [];

      data.forEach((country) => {
        this.selectedCountry.push(country.ID);
      });
      this.updateStatesBasedOnCountry(23, true);
    }
    if (this.selectedCountry.length === 0) {
      this.selectedState = [];
      this.selectedCity = [];
    }
  }

  onStateSelect(data) {
    // 1 June pramod
    if (this.selectedState !== null && this.selectedState.length > 0) {
      if (this.selectedState[0]?.Name !== undefined) {
        const selectedstates = [];
        this.selectedState.forEach((state) => selectedstates.push(state.ID));
        this.selectedState = selectedstates;
      }
    }
    if (data['selectAll'] !== undefined) {
      const state = data['item']['id'];
      const isChecked = data['isChecked'];
      if (state !== 0 && isChecked === true) {
        this.selectedState.push(state);
      } else {
        this.selectedState.forEach((item, index) => {
          if (item === state) this.selectedState.splice(index, 1);
        });
      }

      this.cityList = [];

      for (let i = 0; i < this.selectedState.length; i++) {
        const updatedCityList = this.facilitatorService.onDropdownSelect(
          this.selectedState[i],
          this.masterData,
          'Cities',
          'StateID'
        );

        updatedCityList.forEach((city) => {
          this.cityList.push(city);
        });
      }
    } else if (data.length === 0) {
      this.selectedState = [];
      this.selectedCity = [];
    } else {
      this.selectedState = [];
      data.forEach((state) => {
        this.selectedState.push(state.ID);
      });

      //Kalyani- In case if we select All State then we should get the list of all cities
      this.cityList = [];
      let updatedCityList;
      for (let i = 0; i < this.selectedState.length; i++) {
        updatedCityList = this.facilitatorService.onDropdownSelect(
          this.selectedState[i],
          this.masterData,
          'Cities',
          'StateID'
        );
        updatedCityList.forEach((city) => {
          this.cityList.push(city);
        });
      }
    }
    this.cityList.sort(this.SortArrayCity);
    //pramod 27 may
    if (this.selectedCity !== null && this.selectedCity.length > 0) {
      if (this.selectedCity[0]?.CityName !== undefined) {
        const selectedcities = [];
        this.selectedCity.forEach((city) => selectedcities.push(city.CityID));
        this.selectedCity = selectedcities;
      }
    }
    //26 may pramod
    const tempSelectedCity = [];
    this.updatedCityDataList = [];
    this.selectedCity.forEach((id) => {
      if (this.cityList.some((e) => e.CityID === id)) {
        tempSelectedCity.push(id);
        // for placeholder 30 may
        const item = this.cityList.filter((data) => data.CityID === id);
        this.updatedCityDataList.push(item);
      }
    });
    this.selectedCity = tempSelectedCity;
  }

  onCitySelect(data) {
    //pramod 1 June
    if (this.selectedCity !== null && this.selectedCity.length > 0) {
      if (this.selectedCity[0]?.CityName !== undefined) {
        const selectedcities = [];
        this.selectedCity.forEach((city) => selectedcities.push(city.CityID));
        this.selectedCity = selectedcities;
      }
    }
    if (data['selectAll'] !== undefined) {
      const city = data['item']['id'];
      const isChecked = data['isChecked'];
      if (city !== 0 && isChecked === true) {
        this.selectedCity.push(city);
      } else {
        this.selectedCity.forEach((item, index) => {
          if (item === city) this.selectedCity.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedCity = [];
    } else {
      this.selectedCity = [];
      data.forEach((city) => {
        this.selectedCity.push(city.ID);
      });
    }
  }

  onFunctionSelect(data) {
    // 1 June pramod
    if (this.selectedFunction !== null && this.selectedFunction.length > 0) {
      if (this.selectedFunction[0].Name !== undefined) {
        const selectedfunction = [];
        this.selectedFunction.forEach((sfunction) =>
          selectedfunction.push(sfunction.ID)
        );
        this.selectedFunction = selectedfunction;
      }
    }
    if (data['selectAll'] !== undefined) {
      const functionID = data['item']['id'];
      const isChecked = data['isChecked'];
      if (functionID !== 0 && isChecked === true) {
        this.selectedFunction.push(functionID);
      } else {
        this.selectedFunction.forEach((item, index) => {
          if (item === functionID) this.selectedFunction.splice(index, 1);
        });
      }

      this.serviceList = [];
      for (let i = 0; i < this.selectedFunction.length; i++) {
        const updatedServiceList = this.facilitatorService.onDropdownSelect(
          this.selectedFunction[i],
          this.masterData,
          'ServiceAreas',
          'ServiceFunctionID'
        );

        updatedServiceList.forEach((serviceList) => {
          this.serviceList.push(serviceList);
        });
      }
    } else if (data.length === 0) {
      this.selectedFunction = [];
    } else {
      this.selectedFunction = [];
      data.forEach((funct) => {
        this.selectedFunction.push(funct.ID);
      });

      let updatedServiceList;
      this.serviceList = [];
      for (let i = 0; i < this.selectedFunction.length; i++) {
        updatedServiceList = this.facilitatorService.onDropdownSelect(
          this.selectedFunction[i],
          this.masterData,
          'ServiceAreas',
          'ServiceFunctionID'
        );
        updatedServiceList.forEach((serviceList) => {
          this.serviceList.push(serviceList);
        });
      }
    }
    this.serviceList.sort(this.SortArrayServiceList);

    // 27 may pramod
    if (this.selectedService !== null && this.selectedService.length > 0) {
      if (this.selectedService[0].ServiceAreaName !== undefined) {
        const selectedservices = [];
        this.selectedService.forEach((sservices) =>
          selectedservices.push(sservices.ServiceAreaID)
        );
        this.selectedService = selectedservices;
      }
    }

    // 123 pramod 26 may
    const tempSelectedService = [];
    this.updatedServiceDataList = [];
    this.selectedService.forEach((id) => {
      if (this.serviceList.some((e) => e.ServiceAreaID === id)) {
        tempSelectedService.push(id);
        // for placeholder 30 may
        const item = this.serviceList.filter(
          (data) => data.ServiceAreaID === id
        );
        this.updatedServiceDataList.push(item);
      }
    });
    this.selectedService = tempSelectedService;
  }

  onServiceSelect(data) {
    // 1 June pramod
    if (this.selectedService !== null && this.selectedService.length > 0) {
      if (this.selectedService[0].ServiceAreaName !== undefined) {
        const selectedservices = [];
        this.selectedService.forEach((sservices) =>
          selectedservices.push(sservices.ServiceAreaID)
        );
        this.selectedService = selectedservices;
      }
    }
    if (data['selectAll'] !== undefined) {
      const service = data['item']['id'];
      const isChecked = data['isChecked'];
      if (service !== 0 && isChecked === true) {
        this.selectedService.push(service);
      } else {
        this.selectedService.forEach((item, index) => {
          if (item === service) this.selectedService.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedService = [];
    } else {
      this.selectedService = [];
      data.forEach((service) => {
        this.selectedService.push(service.ServiceAreaID);
      });
    }
  }

  onLevelSelect(data) {
    // 1 June pramod
    if (this.selectedJobLevel !== null && this.selectedJobLevel.length > 0) {
      if (this.selectedJobLevel[0].Name !== undefined) {
        const selectedlevels = [];
        this.selectedJobLevel.forEach((slevels) =>
          selectedlevels.push(slevels.ID)
        );
        this.selectedJobLevel = selectedlevels;
      }
    }
    if (data['selectAll'] !== undefined) {
      const level = data['item']['id'];
      const isChecked = data['isChecked'];
      if (level !== 0 && isChecked === true) {
        this.selectedJobLevel.push(level);
      } else {
        this.selectedJobLevel.forEach((item, index) => {
          if (item === level) this.selectedJobLevel.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedJobLevel = [];
    } else {
      this.selectedJobLevel = [];
      data.forEach((job) => {
        this.selectedJobLevel.push(job.ID);
      });
    }
  }

  onIndustrySelect(data) {
    //pramod 1 June
    if (this.selectedIndustry !== null && this.selectedIndustry.length > 0) {
      if (this.selectedIndustry[0].Name !== undefined) {
        const selectedareas = [];
        this.selectedIndustry.forEach((sareas) =>
          selectedareas.push(sareas.ID)
        );
        this.selectedIndustry = selectedareas;
      }
    }
    if (data['selectAll'] !== undefined) {
      const IndustryID = data['item']['id'];
      const isChecked = data['isChecked'];
      if (IndustryID !== 0 && isChecked === true) {
        this.selectedIndustry.push(IndustryID);
      } else {
        this.selectedIndustry.forEach((item, index) => {
          if (item === IndustryID) this.selectedIndustry.splice(index, 1);
        });
      }

      this.sectorList = [];
      for (let i = 0; i < this.selectedIndustry.length; i++) {
        const updatedSectorList = this.facilitatorService.onDropdownSelect(
          this.selectedIndustry[i],
          this.masterData,
          'Sectors',
          'IndustryID'
        );

        updatedSectorList.forEach((SectorList) => {
          this.sectorList.push(SectorList);
        });
      }
    } else if (data.length === 0) {
      this.selectedIndustry = [];
    } else {
      this.selectedIndustry = [];
      data.forEach((industry) => {
        this.selectedIndustry.push(industry.ID);
      });

      //KALYANI- INCASE OF SELECTING ALL AND IF IT INCLUDE NOT aVAILABLE VALUE THEN IN THAT CASE WE SHOULD GET ALL VALUES
      this.sectorList = [];
      let updatedSectorList;
      for (let i = 0; i < this.selectedIndustry.length; i++) {
        updatedSectorList = this.facilitatorService.onDropdownSelect(
          this.selectedIndustry[i],
          this.masterData,
          'Sectors',
          'IndustryID'
        );

        updatedSectorList.forEach((sectorList) => {
          this.sectorList.push(sectorList);
        });
      }
    }
    // pramod 27 may
    if (this.selectedSector !== null && this.selectedSector.length > 0) {
      if (this.selectedSector[0].SectorName !== undefined) {
        const selectedSectors = [];
        this.selectedSector.forEach((ssectors) =>
          selectedSectors.push(ssectors.SectorID)
        );
        this.selectedSector = selectedSectors;
      }
    }
    //26 may pramod
    const tempSelectedSector = [];
    this.updatedSectorDataList = [];
    this.selectedSector.forEach((id) => {
      if (this.sectorList.some((e) => e.SectorID === id)) {
        tempSelectedSector.push(id);
        // for placeholder 30 may
        const item = this.sectorList.filter((data) => data.SectorID === id);
        this.updatedSectorDataList.push(item);
      }
    });
    this.selectedSector = tempSelectedSector;
    this.sectorList.sort(this.SortArraySectorList);
  }

  onSectorSelect(data) {
    // pramod 1 June
    if (this.selectedSector !== null && this.selectedSector.length > 0) {
      if (this.selectedSector[0].SectorName !== undefined) {
        const selectedSectors = [];
        this.selectedSector.forEach((ssectors) =>
          selectedSectors.push(ssectors.SectorID)
        );
        this.selectedSector = selectedSectors;
      }
    }
    if (data['selectAll'] !== undefined) {
      const sector = data['item']['id'];
      const isChecked = data['isChecked'];
      if (sector !== 0 && isChecked === true) {
        this.selectedSector.push(sector);
      } else {
        this.selectedSector.forEach((item, index) => {
          if (item === sector) this.selectedSector.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedSector = [];
    } else {
      this.selectedSector = [];
      data.forEach((sector) => {
        this.selectedSector.push(sector.SectorID);
      });
    }
  }

  selectedExperienceLevel(data) {
    // 1 June pramod
    if (
      this.selectedExperienceLevelRange !== null &&
      this.selectedExperienceLevelRange.length > 0
    ) {
      if (this.selectedExperienceLevelRange[0].SessionsRange !== undefined) {
        const selecteddeloitteData = [];
        this.selectedExperienceLevelRange.forEach((data) =>
          selecteddeloitteData.push(data.SessionsRange)
        );
        this.selectedExperienceLevelRange = selecteddeloitteData;
      }
    }
    if (data['selectAll'] !== undefined) {
      const model = data['item']['id'];
      const isChecked = data['isChecked'];
      if (model !== 0 && isChecked === true) {
        this.selectedExperienceLevelRange.push(model);
      } else {
        this.selectedExperienceLevelRange.forEach((item, index) => {
          if (item === model)
            this.selectedExperienceLevelRange.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedExperienceLevelRange = [];
    } else {
      this.selectedExperienceLevelRange = data;
    }
  }

  onDeliveryModelSelect(data) {
    // 1 June pramod
    if (
      this.selectedDeliveryModel !== null &&
      this.selectedDeliveryModel.length > 0
    ) {
      if (this.selectedDeliveryModel[0].SessionFormatName !== undefined) {
        const selecteddeliverymodels = [];
        this.selectedDeliveryModel.forEach((deliverymodels) =>
          selecteddeliverymodels.push(deliverymodels.SessionFormatID)
        );
        this.selectedDeliveryModel = selecteddeliverymodels;
      }
    }

    if (data['selectAll'] !== undefined) {
      const model = data['item']['id'];
      const isChecked = data['isChecked'];
      if (model !== 0 && isChecked === true) {
        this.selectedDeliveryModel.push(model);
      } else {
        this.selectedDeliveryModel.forEach((item, index) => {
          if (item === model) this.selectedDeliveryModel.splice(index, 1);
        });
      }
    } else if (data.length === 0) {
      this.selectedDeliveryModel = [];
    } else {
      this.selectedDeliveryModel = [];
      data.forEach((model) => {
        this.selectedDeliveryModel.push(model.SessionFormatID);
      });
    }
  }

  updateStatesBasedOnCountry(country, isChecked) {
    this.stateList = [];
    this.selectedCountry.forEach((countryID) => {
      if (countryID === 23 || countryID === 265 || countryID === 259 || countryID === 267 || countryID === 268 || countryID === 269 ) {
        const updatedStateList = this.facilitatorService.onDropdownSelect(
          countryID,
          this.masterData,
          'States',
          'CountryID'
        );

        updatedStateList.forEach((state) => {
          this.stateList.push(state);
        });
      }
    });

    const usCountryIds = [23, 259, 265, 267,268,269];
    const selectedUsCountries = this.selectedCountry.filter(id => usCountryIds.includes(id)); 
    this.disableState = selectedUsCountries.length > 0 ? false : true;

    this.stateList.sort(this.SortArray);

    //Need to clarify: why we are making selected state is empty if we select afganiatan
    if (this.selectedCountry.length === 0) {
      this.selectedState = [];
      this.selectedCity = [];
      document
        .getElementsByName('StateID')[0]
        .getElementsByClassName(
          'dropdown'
        )[0].childNodes[0].childNodes[0].textContent = 'Select';
    }
    // 27 may pramod
    if (this.selectedState !== null && this.selectedState.length > 0) {
      if (this.selectedState[0].Name !== undefined) {
        const selectedstates = [];
        this.selectedState.forEach((state) => selectedstates.push(state.ID));
        this.selectedState = selectedstates;
      }
    }
    //26 may pramod
    const tempSelectedState = [];
    this.updatedStateDataList = [];
    this.selectedState.forEach((id) => {
      if (this.stateList.some((e) => e.ID === id)) {
        tempSelectedState.push(id);
        // for placeholder 30 may
        const item = this.stateList.filter((data) => data.ID === id);
        this.updatedStateDataList.push(item);
      }
    });
    this.selectedState = tempSelectedState;
  }
  SortArray(x, y) {
    return x.Name.localeCompare(y.Name);
  }

  SortArrayCity(x, y) {
    return x.CityName.localeCompare(y.CityName);
  }

  SortArrayServiceList(x, y) {
    return x.ServiceAreaName.localeCompare(y.ServiceAreaName);
  }

  SortArraySectorList(x, y) {
    return x.SectorName.localeCompare(y.SectorName);
  }

  updateCitiesBasedOnCountry(country) {
    this.cityList = [];
    this.selectedState.forEach((state) => {
      const cities = this.facilitatorService.onDropdownSelect(
        state,
        this.masterData,
        'Cities',
        'StateID'
      );
      cities.forEach((city) => {
        this.cityList.push(city);
      });
    });

    //pramod 27 may
    if (this.selectedCity !== null && this.selectedCity.length > 0) {
      if (this.selectedCity[0].CityName !== undefined) {
        const selectedcities = [];
        this.selectedCity.forEach((city) => selectedcities.push(city.CityID));
        this.selectedCity = selectedcities;
      }
    }
    //26 may pramod
    const tempSelectedCity = [];
    this.updatedCityDataList = [];
    this.selectedCity.forEach((id) => {
      if (this.cityList.some((e) => e.CityID === id)) {
        tempSelectedCity.push(id);
        // for placeholder 30 may
        const item = this.cityList.filter((data) => data.CityID === id);
        this.updatedCityDataList.push(item);
      }
    });
    this.selectedCity = tempSelectedCity;
  }

  updateServiceFunctionBasedOnCountry(country) {
    let i = 0;
    let j = 0;
    let updatedFunctionList = [];
    this.functionList = [];

    for (let k = 0; k < this.selectedCountry.length; k++) {
      if (
        this.selectedCountry[k] === 23 ||
        this.selectedCountry[k] === 259 ||
        this.selectedCountry[k] === 265
      ) {
        i = i + 1;
      } else {
        j = j + 1;
      }
    }

    //23, 259,265 Only US with MDR true
    if (i !== 0 && i <= 3 && j === 0) {
      updatedFunctionList = [];
      this.functionList = [];
      updatedFunctionList = this.facilitatorService.updateListBasedOnCountry(
        23,
        this.masterData,
        'ServiceFunctions'
      );

      updatedFunctionList.forEach((functionData) => {
        this.functionList.push(functionData);
      });
    } else if (i !== 0 && i <= 3 && j !== 0) {
      updatedFunctionList = [];
      this.functionList = [];
      //23, 265,259, 87 US + Non US MDR true+false
      const tempSelectedCountryList = [23, 87];
      for (let i = 0; i < tempSelectedCountryList.length; i++) {
        updatedFunctionList = this.facilitatorService.updateListBasedOnCountry(
          tempSelectedCountryList[i],
          this.masterData,
          'ServiceFunctions'
        );

        updatedFunctionList.forEach((functionData) => {
          this.functionList.push(functionData);
        });
      }
    } else if (i === 0 && j !== 0) {
      //Non US MDR False
      //like 87 -Afganistan
      updatedFunctionList = [];
      this.functionList = [];
      updatedFunctionList = this.facilitatorService.updateListBasedOnCountry(
        87,
        this.masterData,
        'ServiceFunctions'
      );

      updatedFunctionList.forEach((functionData) => {
        this.functionList.push(functionData);
      });
    }

    this.functionList.sort(this.SortArray);

    if (this.selectedCountry.length === 0) {
      this.selectedFunction = [];
      document
        .getElementsByName('FunctionID')[0]
        .getElementsByClassName(
          'dropdown'
        )[0].childNodes[0].childNodes[0].textContent = 'Select';
    }
    //pramod 27 may
    if (this.selectedFunction !== null && this.selectedFunction.length > 0) {
      if (this.selectedFunction[0].Name !== undefined) {
        const selectedfunctions = [];
        this.selectedFunction.forEach((sfunction) =>
          selectedfunctions.push(sfunction.ID)
        );
        this.selectedFunction = selectedfunctions;
      }
    }
    // 123 pramod 26 may
    const tempSelectedFunction = [];
    this.updatedFunctionDataList = [];
    this.selectedFunction.forEach((id) => {
      if (this.functionList.some((e) => e.ID === id)) {
        tempSelectedFunction.push(id);
        // for placeholder 30 may
        const item = this.functionList.filter((data) => data.ID === id);
        this.updatedFunctionDataList.push(item);
      }
    });
    this.selectedFunction = tempSelectedFunction;
  }

  updateServiceAreaBasedOnCountry(country) {
    // 1 June pramod
    if (this.selectedFunction && this.selectedFunction.length !== 0) {
      this.serviceList = [];
      for (let i = 0; i < this.selectedFunction.length; i++) {
        const updatedServiceList = this.facilitatorService.onDropdownSelect(
          this.selectedFunction[i],
          this.masterData,
          'ServiceAreas',
          'ServiceFunctionID'
        );
        updatedServiceList.forEach((serviceList) => {
          this.serviceList.push(serviceList);
        });
      }
    } else {
      this.serviceList = [];
      let i = 0;
      let j = 0;
      let updatedServiceAreaList = [];

      for (let k = 0; k < this.selectedCountry.length; k++) {
        if (
          this.selectedCountry[k] === 23 ||
          this.selectedCountry[k] === 259 ||
          this.selectedCountry[k] === 265
        ) {
          i = i + 1;
        } else {
          j = j + 1;
        }
      }

      //23, 259,265 Only US with MDR true
      if (i !== 0 && i <= 3 && j === 0) {
        updatedServiceAreaList = [];
        this.serviceList = [];

        updatedServiceAreaList =
          this.facilitatorService.updateListBasedOnCountry(
            23,
            this.masterData,
            'ServiceAreas'
          );

        updatedServiceAreaList.forEach((serviceList) => {
          this.serviceList.push(serviceList);
        });
      } else if (i !== 0 && i <= 3 && j !== 0) {
        updatedServiceAreaList = [];
        this.serviceList = [];
        //23, 265,259, 87 US + Non US MDR true+false
        const tempSelectedCountryList = [23, 87];
        for (let i = 0; i < tempSelectedCountryList.length; i++) {
          updatedServiceAreaList =
            this.facilitatorService.updateListBasedOnCountry(
              tempSelectedCountryList[i],
              this.masterData,
              'ServiceAreas'
            );

          updatedServiceAreaList.forEach((serviceList) => {
            this.serviceList.push(serviceList);
          });
        }
      } else if (i === 0 && j !== 0) {
        //Non US MDR False
        //like 87 -Afganistan
        updatedServiceAreaList = [];
        this.serviceList = [];

        updatedServiceAreaList =
          this.facilitatorService.updateListBasedOnCountry(
            87,
            this.masterData,
            'ServiceAreas'
          );

        updatedServiceAreaList.forEach((serviceList) => {
          this.serviceList.push(serviceList);
        });
      }
    }

    this.serviceList.sort(this.SortArrayServiceList);

    if (this.selectedCountry.length === 0) {
      this.selectedService = [];
      document
        .getElementsByName('ServiceID')[0]
        .getElementsByClassName(
          'dropdown'
        )[0].childNodes[0].childNodes[0].textContent = 'Select';
    }
    //pramod 27 may
    if (this.selectedService !== null && this.selectedService.length > 0) {
      if (this.selectedService[0].ServiceAreaName !== undefined) {
        const selectedservices = [];
        this.selectedService.forEach((sservices) =>
          selectedservices.push(sservices.ServiceAreaID)
        );
        this.selectedService = selectedservices;
      }
    }

    //pramod 26may
    const tempSelectedService = [];
    this.updatedServiceDataList = [];
    this.selectedService.forEach((id) => {
      if (this.serviceList.some((e) => e.ServiceAreaID === id)) {
        tempSelectedService.push(id);
        // for placeholder 30 may
        const item = this.serviceList.filter(
          (data) => data.ServiceAreaID === id
        );
        this.updatedServiceDataList.push(item);
      }
    });
    this.selectedService = tempSelectedService;
  }

  updateIndustriesBasedOnCountry(country) {
    let i = 0;
    let j = 0;
    let updatedIndustriesList = [];
    this.industryList = [];

    for (let k = 0; k < this.selectedCountry.length; k++) {
      if (
        this.selectedCountry[k] === 23 ||
        this.selectedCountry[k] === 259 ||
        this.selectedCountry[k] === 265
      ) {
        i = i + 1;
      } else {
        j = j + 1;
      }
    }

    //23, 259,265 Only US with MDR true
    if (i !== 0 && i <= 3 && j === 0) {
      updatedIndustriesList = [];
      this.industryList = [];

      updatedIndustriesList = this.facilitatorService.updateListBasedOnCountry(
        23,
        this.masterData,
        'Industries'
      );

      updatedIndustriesList.forEach((industryList) => {
        this.industryList.push(industryList);
      });
    } else if (i !== 0 && i <= 3 && j !== 0) {
      updatedIndustriesList = [];
      this.industryList = [];

      //23, 265,259, 87 US + Non US MDR true+false
      const tempSelectedCountryList = [23, 87];
      for (let i = 0; i < tempSelectedCountryList.length; i++) {
        updatedIndustriesList =
          this.facilitatorService.updateListBasedOnCountry(
            tempSelectedCountryList[i],
            this.masterData,
            'Industries'
          );

        updatedIndustriesList.forEach((industryList) => {
          this.industryList.push(industryList);
        });
      }
    } else if (i === 0 && j !== 0) {
      //Non US MDR False
      //like 87 -Afganistan
      updatedIndustriesList = [];
      this.industryList = [];

      updatedIndustriesList = this.facilitatorService.updateListBasedOnCountry(
        87,
        this.masterData,
        'Industries'
      );

      updatedIndustriesList.forEach((industryList) => {
        this.industryList.push(industryList);
      });
    }

    this.industryList.sort(this.SortArray);

    if (this.selectedCountry.length === 0) {
      this.selectedIndustry = [];
      document
        .getElementsByName('IndustryID')[0]
        .getElementsByClassName(
          'dropdown'
        )[0].childNodes[0].childNodes[0].textContent = 'Select';
    }
    //pramod 27 may
    if (this.selectedIndustry !== null && this.selectedIndustry.length > 0) {
      if (this.selectedIndustry[0].Name !== undefined) {
        const selectedareas = [];
        this.selectedIndustry.forEach((sareas) =>
          selectedareas.push(sareas.ID)
        );
        this.selectedIndustry = selectedareas;
      }
    }
    // 123 pramod 26 may
    const tempSelectedIndustry = [];
    this.updatedIndustryDataList = [];
    this.selectedIndustry.forEach((id) => {
      if (this.industryList.some((e) => e.ID === id)) {
        tempSelectedIndustry.push(id);
        // for placeholder 30 may
        const item = this.industryList.filter((data) => data.ID === id);
        this.updatedIndustryDataList.push(item);
      }
    });
    this.selectedIndustry = tempSelectedIndustry;
  }

  updateSectorsBasedOnCountry(country) {
    // 1 June pramod
    if (this.selectedIndustry && this.selectedIndustry.length !== 0) {
      this.sectorList = [];
      for (let i = 0; i < this.selectedIndustry.length; i++) {
        const updatedSectorList = this.facilitatorService.onDropdownSelect(
          this.selectedIndustry[i],
          this.masterData,
          'Sectors',
          'IndustryID'
        );

        updatedSectorList.forEach((SectorList) => {
          this.sectorList.push(SectorList);
        });
      }
    } else {
      let i = 0;
      let j = 0;
      let updatedsectorList = [];
      this.sectorList = [];

      for (let k = 0; k < this.selectedCountry.length; k++) {
        if (
          this.selectedCountry[k] === 23 ||
          this.selectedCountry[k] === 259 ||
          this.selectedCountry[k] === 265
        ) {
          i = i + 1;
        } else {
          j = j + 1;
        }
      }

      //23, 259,265 Only US with MDR true
      if (i !== 0 && i <= 3 && j === 0) {
        updatedsectorList = [];
        this.sectorList = [];

        updatedsectorList = this.facilitatorService.updateListBasedOnCountry(
          23,
          this.masterData,
          'Sectors'
        );
        updatedsectorList.forEach((sectorList) => {
          this.sectorList.push(sectorList);
        });
      } else if (i !== 0 && i <= 3 && j !== 0) {
        updatedsectorList = [];
        this.sectorList = [];

        //23, 265,259, 87 US + Non US MDR true+false
        const tempSelectedCountryList = [23, 87];
        for (let i = 0; i < tempSelectedCountryList.length; i++) {
          updatedsectorList = this.facilitatorService.updateListBasedOnCountry(
            tempSelectedCountryList[i],
            this.masterData,
            'Sectors'
          );
          updatedsectorList.forEach((sectorList) => {
            this.sectorList.push(sectorList);
          });
        }
      } else if (i === 0 && j !== 0) {
        //Non US MDR False
        //like 87 -Afganistan
        updatedsectorList = [];
        this.sectorList = [];

        updatedsectorList = this.facilitatorService.updateListBasedOnCountry(
          87,
          this.masterData,
          'Sectors'
        );
        updatedsectorList.forEach((sectorList) => {
          this.sectorList.push(sectorList);
        });
      }
    }

    this.sectorList.sort(this.SortArraySectorList);

    if (this.selectedCountry.length === 0) {
      this.selectedSector = [];
      document
        .getElementsByName('SectorID')[0]
        .getElementsByClassName(
          'dropdown'
        )[0].childNodes[0].childNodes[0].textContent = 'Select';
    }
    // pramod 27 may
    if (this.selectedSector !== null && this.selectedSector.length > 0) {
      if (this.selectedSector[0].SectorName !== undefined) {
        const selectedSectors = [];
        this.selectedSector.forEach((ssectors) =>
          selectedSectors.push(ssectors.SectorID)
        );
        this.selectedSector = selectedSectors;
      }
    }
    // 123 pramod 26 may
    const tempSelectedSector = [];
    this.updatedSectorDataList = [];
    this.selectedSector.forEach((id) => {
      if (this.sectorList.some((e) => e.SectorID === id)) {
        tempSelectedSector.push(id);
        // for placeholder 30 may
        const item = this.sectorList.filter((data) => data.SectorID === id);
        this.updatedSectorDataList.push(item);
      }
    });
    this.selectedSector = tempSelectedSector;
  }

  checkAdvanceSearch(): void {
    if (
      this.selectedFunction.length > 0 ||
      this.selectedService.length > 0 ||
      this.selectedIndustry.length > 0 ||
      this.selectedSector.length > 0 ||
      this.selectedDeliveryModel.length > 0 ||
      (this.selectedName !== '' && this.selectedName !== null)
    ) {
      this.isAdvanceSearch = true;
    } else {
      this.isAdvanceSearch = false;
    }
  }
  onSearch(pageNumber, sortColumn, sortOrder, resetEmailSelection?) {
    this.checkDisability();
    if (!this.disableButtons) {
      this.showLoader = true;

      if (
        this.selectedExperienceLevelRange !== null &&
        this.selectedExperienceLevelRange.length > 0
      ) {
        if (this.selectedExperienceLevelRange[0].SessionsRange !== undefined) {
          const selecteddeloitteData = [];
          this.selectedExperienceLevelRange.forEach((data) =>
            selecteddeloitteData.push(data.SessionsRange)
          );
          this.selectedExperienceLevelRange = selecteddeloitteData;
        }
      }
      const minExperienceLevelSelected = [];
      for (let i = 0; i < this.selectedExperienceLevelRange.length; i++) {
        const clientData = this.getRangeFormatted(
          this.selectedExperienceLevelRange[i]
        );
        minExperienceLevelSelected.push(clientData);
      }

      if (this.selectedCountry !== null && this.selectedCountry.length > 0) {
        this.selectedCountry = this.selectedCountry.filter(function (element) {
          return element !== undefined;
        });
        if (this.selectedCountry[0]?.Name !== undefined) {
          const selectedcountries = [];
          this.selectedCountry.forEach((country) =>
            selectedcountries.push(country.ID)
          );
          this.selectedCountry = selectedcountries;
        }
      }

      if (this.selectedState !== null && this.selectedState.length > 0) {
        if (this.selectedState[0]?.Name !== undefined) {
          const selectedstates = [];
          this.selectedState.forEach((state) => selectedstates.push(state.ID));
          this.selectedState = selectedstates;
        }
      }

      if (this.selectedCity !== null && this.selectedCity.length > 0) {
        if (this.selectedCity[0]?.CityName !== undefined) {
          const selectedcities = [];
          this.selectedCity.forEach((city) => selectedcities.push(city.CityID));
          this.selectedCity = selectedcities;
        }
      }

      if (this.selectedFunction !== null && this.selectedFunction.length > 0) {
        if (this.selectedFunction[0].Name !== undefined) {
          const selectedfunctions = [];
          this.selectedFunction.forEach((sfunction) =>
            selectedfunctions.push(sfunction.ID)
          );
          this.selectedFunction = selectedfunctions;
        }
      }

      if (this.selectedService !== null && this.selectedService.length > 0) {
        if (this.selectedService[0].ServiceAreaName !== undefined) {
          const selectedservices = [];
          this.selectedService.forEach((sservices) =>
            selectedservices.push(sservices.ServiceAreaID)
          );
          this.selectedService = selectedservices;
        }
      }

      if (this.selectedJobLevel !== null && this.selectedJobLevel.length > 0) {
        if (this.selectedJobLevel[0].Name !== undefined) {
          const selectedlevels = [];
          this.selectedJobLevel.forEach((slevels) =>
            selectedlevels.push(slevels.ID)
          );
          this.selectedJobLevel = selectedlevels;
        }
      }

      if (this.selectedIndustry !== null && this.selectedIndustry.length > 0) {
        if (this.selectedIndustry[0].Name !== undefined) {
          const selectedareas = [];
          this.selectedIndustry.forEach((sareas) =>
            selectedareas.push(sareas.ID)
          );
          this.selectedIndustry = selectedareas;
        }
      }

      if (this.selectedSector !== null && this.selectedSector.length > 0) {
        if (this.selectedSector[0].SectorName !== undefined) {
          const selectedSectors = [];
          this.selectedSector.forEach((ssectors) =>
            selectedSectors.push(ssectors.SectorID)
          );
          this.selectedSector = selectedSectors;
        }
      }

      if (
        this.selectedDeliveryModel !== null &&
        this.selectedDeliveryModel.length > 0
      ) {
        if (this.selectedDeliveryModel[0].SessionFormatName !== undefined) {
          const selecteddeliverymodels = [];
          this.selectedDeliveryModel.forEach((deliverymodels) =>
            selecteddeliverymodels.push(deliverymodels.SessionFormatID)
          );
          this.selectedDeliveryModel = selecteddeliverymodels;
        }
      }
      const selectedCountryPayload = this.selectedCountry;
      const selectedStatePayload = this.selectedState;
      const selectedCityPayload = this.selectedCity;
      const selectedFunctionPayload = this.selectedFunction;
      const selectedServicePayload = this.selectedService;
      const selectedJobLevelPayload = this.selectedJobLevel;
      const selectedIndustryPayload = this.selectedIndustry;

      const selectedSectorPayload = this.selectedSector;
      const selectedDeliveryModelPayload = this.selectedDeliveryModel;
      this.checkAdvanceSearch();
      const presenter = {
        name: this.selectedName,
        countryID: selectedCountryPayload.toString(),
        stateID: selectedStatePayload.toString(),
        cityID: selectedCityPayload.toString(),
        officeID: 0,
        servicefunctionID: selectedFunctionPayload.toString(),
        serviceAreaID: selectedServicePayload.toString(),
        servicelineID: 0,
        joblevelID: selectedJobLevelPayload.toString(),
        industryID: selectedIndustryPayload.toString(),
        sectorID: selectedSectorPayload.toString(),
        certificationlevelID:
          this.selectedCertificationLevel === 3
            ? 0
            : Number(this.selectedCertificationLevel),
        contentAreaID: Number(this.selectedContentArea ?? 0),
        topicID: Number(this.selectedTopic ?? 0),
        ExperienceLevel: minExperienceLevelSelected.toString(),
        maxDeloitteSessionsFacilitated: 0,
        maxClientSessionsFacilitated: 0,
        PageNumber: Number(pageNumber) ? Number(pageNumber) : 1, //this.pageNo,
        RowsperPage: 50,
        SortCol: sortColumn ? sortColumn : 'LastName',
        sortorder: sortOrder ? sortOrder : 'ASC',
        // For US: 2564047: Delivery Model
        sessionFormatID: selectedDeliveryModelPayload.toString(),
      };
      this.exportPayload = presenter;
      this.facilitatorService
        .searchFacilitator(presenter)
        .pipe(takeUntil(this.subscription))
        .subscribe((res) => {
          this.showTable = false;

          if (res) {
            this.emailslist = '';
            this.checkuncheckflag = false;
            this.showTable = true;
            this.loadTableData();
            this.searchAreaFields = res?.length > 0 ? false : true;
            this.seaerchAreaDownArrow = res?.length > 0 ? true : false;
            this.seaerchAreaUpArrow = false;
            this.pageNoToSave = Number(pageNumber) ? Number(pageNumber) : 1;
            //Adding pg no key to set the pg no for the smart grid
            res.forEach((element, index) => {
              res[index]['pageNumber'] = pageNumber;
            });

            this.sampleData = res;

            if (resetEmailSelection) {
              this.emailListAcrossPages = [];
            }

            this.isRequestorAvailabilityDisabled = true;
            if (
              this.emailListAcrossPages !== undefined &&
              this.emailListAcrossPages.length > 0
            ) {
              this.isRequestorAvailabilityDisabled = false;
              const pageData = this.emailListAcrossPages.find(
                (x) => x.page === x.currentPage
              );
              if (
                pageData !== null &&
                pageData !== undefined &&
                pageData.emailslist.length > 0
              ) {
                pageData.emailslist.forEach((emailId) => {
                  const index = this.sampleData.findIndex(
                    (x) => x.Email === emailId
                  );
                  if (index !== null && index !== undefined && index !== -1) {
                    const previousCheckedData = this.sampleData[index];
                    previousCheckedData.checked = true;
                  }
                });
              }
            }
            this.totalRecords = res.length > 0 ? res[0].TotalCount : 0;
            this.showExportBtn = res.length > 0 ? true : false;
            this.showLoader = false;
            this.getTabChange();
          }
        });
    } else {
      this.showTable = true;
      this.loadTableData();
      this.sampleData = [];
      this.totalRecords = 0;
      this.showExportBtn = false;
      this.searchGridHeightSet();
    }
    if (this.flagObject === false) {
      this.flagObject = true;
    } else {
      this.sortOrder = 'ASC';
    }
  }

  rowCheckboxClickEvent(event) {
    if (!event.checked) {
      this.checkuncheckflag = true;
    }
  }

  getRangeFormatted(range) {
    if (range) {
      switch (range) {
        case 'Novice':
          return 1;
        case 'Experienced':
          return 2;
        case 'Very Experienced':
          return 3;
      }
    }
    return 0;
  }

  onClearSelection() {
    this.isAdvanceSearch = false;
    this.searchAreaExpand();

    this.selectedName = '';
    this.selectedCountry = [];
    this.selectedState = [];
    this.selectedCity = [];
    this.selectedFunction = [];
    this.selectedService = [];
    this.selectedJobLevel = [];
    this.selectedIndustry = [];
    this.selectedSector = [];
    this.selectedCertificationLevel = 0;
    this.selectedExperienceLevelRange = [];
    this.showTable = false;
    this.sampleData = [];
    this.isRequestorAvailabilityDisabled = true;
    this.emailListAcrossPages = [];
    this.previousPage = 1;
    this.emailslist = '';
    this.checkuncheckflag = false;
    this.totalRecords = 0;
    this.showExportBtn = false;
    this.selectedDeliveryModel = []; //clearing delivery model field
    this.userType = null;
    this.selectedContentArea = null;
    this.selectedTopic = null;

    this.checkDisability();
    this.getTabChange();
    const elements = document.getElementsByName('resetBtn');
    for (let index = 0; index < elements.length; index++) {
      elements[index].click();
    }
  }

  loadTableData() {
    this.sampleColumns = [
      { name: 'Name', header: 'Name', dataType: 'string', width: '140px' },
      { name: 'Level', header: 'Level', dataType: 'string', width: '140px' },
      {
        name: 'Email',
        header: 'Email',
        dataType: 'string',
        width: '100px',
      },
      {
        name: 'Country',
        header: 'Country/Location',
        dataType: 'string',
        width: '150px',
      },
      { name: 'State', header: 'State', dataType: 'string', width: '100px' },
      { name: 'City', header: 'City', dataType: 'string', width: '100px' },
      {
        name: 'Function',
        header: 'Function',
        dataType: 'string',
        width: '120px',
      },
      {
        name: 'Industry',
        header: 'Industry',
        dataType: 'string',
        width: '120px',
      },
      {
        name: 'CertificationLevel',
        header: 'Certification Level',
        dataType: 'string',
        width: '150px',
      },
      {
        name: 'ContentArea',
        header: 'Content Area',
        dataType: 'string',
        width: '150px',
      },
      {
        name: 'Topic',
        header: 'Topic',
        dataType: 'string',
        width: '300px',
      },
    ];

    this.allowCheckbox = true;
    this.allowSelectAllCheckbox = false;
    this.iseventRegistered = true;
    this.allowPagination = true;
    this.isClientSidePagination = false;

    this.settings = {
      selectMode: 'multi',
      hideSubHeader: true,
      actions: {
        edit: true,
        delete: false,
        position: 'left',
      },
      mode: 'external',
      columns: {
        Name: {
          title: 'Name',
          type: 'html',
          valuePrepareFunction: (value) => {
            return `<a>${value}</a>`;
          },
        },
        Level: {
          title: 'Level',
        },
        Email: {
          title: 'Email',
        },
        Country: {
          title: 'Country/Location',
        },
        State: {
          title: 'State',
        },
        City: {
          title: 'City',
        },
        Function: {
          title: 'Function',
        },
        Industry: {
          title: 'Industry',
        },
        Certificationlevel: {
          title: 'Certification Level',
        },
        ContentArea: {
          title: 'Content Area',
        },
        Topic: {
          title: 'Topic',
        },
      },
    };
  }

  onRowSelect(data) {
    if (data && Object.keys(data).length > 0) {
      const edit_facilitator_Modal = new Modal(
        document.getElementById('edit_facilitator_Modal')
      );
      edit_facilitator_Modal.show();
      this.removeBackdrop();
      // const modalBackdrop = new Modal(document.getElementById('modal-backdrop'));
      // modalBackdrop.hide();
      this.editFacilitatorsDetails = JSON.parse(JSON.stringify(data));

      this.masterDataForEdit = {
        countryList: this.masterData['Countries']
          ? this.masterData['Countries']
          : [],
        stateList: this.masterData['States'] ? this.masterData['States'] : [],
        cityList: this.masterData['Cities'] ? this.masterData['Cities'] : [],
        functionList: this.masterData['ServiceFunctions']
          ? this.masterData['ServiceFunctions']
          : [],
        serviceList: this.masterData['ServiceAreas']
          ? this.masterData['ServiceAreas']
          : [],
        jobLevelList: this.masterData['JobLevels']
          ? this.masterData['JobLevels']
          : [],
        industryList: this.masterData['Industries']
          ? this.masterData['Industries']
          : [],
        sectorList: this.masterData['Sectors']
          ? this.masterData['Sectors']
          : [],
        certificationLevelList: this.masterData['Certificationlevels']
          ? this.masterData['Certificationlevels']
          : [],
        contentAreaList: this.masterData['ContentArea']
          ? this.masterData['ContentArea']
          : [],
        topicList: this.masterData['Topic'] ? this.masterData['Topic'] : [],
        experinceLevelRange: this.experinceLevelRange,
      };
    }
  }

  updateFacilitator(event) {
    if (event) {
      this.onSearch(this.pageNo, this.sortColumn, this.sortOrder);
      const edit_facilitator_Modal = new Modal(
        document.getElementById('edit_facilitator_Modal')
      );
      edit_facilitator_Modal.toggle();
      edit_facilitator_Modal.hide();
      // $("#edit_facilitator_Modal").modal("hide");
    }
  }

  updateListData(pageAndSortData) {
    if (this.emailListAcrossPages.length === 0) {
      let pageData: any;
      const emaillist = this.emailslist.split(';');
      if (this.emailslist.trim() !== '') {
        pageData = {
          page: this.previousPage,
          emailslist: emaillist,
          currentPage: pageAndSortData.pageData.currentPage,
        };
        this.emailListAcrossPages.push(pageData);
      }
    } else {
      const pageData = this.emailListAcrossPages.find(
        (x) => x.page === this.previousPage
      );

      if (pageData !== null && pageData !== undefined) {
        const index = this.emailListAcrossPages.findIndex(
          (x) => x.page === this.previousPage
        );
        const emaillist = this.emailslist.split(';');

        if (this.emailslist.trim() !== '') {
          pageData.emailslist = emaillist;
          pageData.currentPage = pageAndSortData.pageData.currentPage;
          this.emailListAcrossPages[index] = pageData;
        } else if (
          this.emailslist.trim() === '' &&
          this.checkuncheckflag === true
        ) {
          this.emailListAcrossPages = this.emailListAcrossPages.filter(
            (x) => x.page !== this.previousPage
          );
        }
      } else {
        const emaillist = this.emailslist.split(';');
        if (this.emailslist.trim() !== '') {
          const pageData: any = {
            page: this.previousPage,
            emailslist: emaillist,
            currentPage: pageAndSortData.pageData.currentPage,
          };
          this.emailListAcrossPages.push(pageData);
        }
      }
    }

    this.previousPage = pageAndSortData.pageData.currentPage;

    if (this.emailListAcrossPages.length > 0) {
      this.emailListAcrossPages.forEach(
        (x) => (x.currentPage = pageAndSortData.pageData.currentPage)
      );
    }

    window.scrollTo(0, 0);
    if (pageAndSortData.pageData && pageAndSortData.pageData.currentPage) {
      if (pageAndSortData.column) {
        if (pageAndSortData.column && pageAndSortData.column === 'Name') {
          this.sortColumn = 'LastName';
        } else if (
          pageAndSortData.column &&
          pageAndSortData.column === 'Country'
        ) {
          this.sortColumn = 'country';
        } else {
          this.sortColumn = pageAndSortData.column;
        }
        this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      }
      this.flagObject = false;
      this.onSearchClicked = true;
      this.onSearch(
        pageAndSortData.pageData.currentPage,
        this.sortColumn,
        this.sortOrder
      ); //to persist the pg no. on page change
    }
  }

  onCheckboxChange(emailList: Array<string>) {
    const emailArray = emailList;
    this.emailslist = emailList.join(';');
    let counter = 0;
    if (
      this.emailListAcrossPages !== null &&
      this.emailListAcrossPages !== undefined &&
      this.emailListAcrossPages.length > 0
    ) {
      this.emailListAcrossPages.forEach((x) => {
        if (x.page !== x.currentPage) {
          counter = counter + x.emailslist.length;
        }
      });
    }
    counter = counter + emailList.length;
    if (counter > 0 && counter <= 10) {
      this.isRequestorAvailabilityDisabled = false;
    } else {
      this.isRequestorAvailabilityDisabled = true;
    }

    this.emailListAcrossPages.map((data) => {
      if (data.page === this.pageNoToSave) {
        data.emailslist = emailArray;
      } else if (
        !this.emailListAcrossPages.find(
          (data) => data.page === this.pageNoToSave
        )
      ) {
        this.emailListAcrossPages.push({
          page: this.pageNoToSave,
          emailslist: emailArray,
          currentPage: this.pageNoToSave,
        });
      }
    });
  }

  onSelectAllCheckboxChange(event) {
    const eventLength = event.filter((x) => x.checked === true).length;
    let counter = 0;
    if (
      this.emailListAcrossPages !== null &&
      this.emailListAcrossPages !== undefined &&
      this.emailListAcrossPages.length > 0
    ) {
      this.emailListAcrossPages.forEach((x) => {
        if (x.page !== x.currentPage) {
          counter = counter + x.emailslist.length;
        }
      });
    }
    counter = counter + eventLength;
    if (eventLength > 0) {
      this.emailslist = '';
      event.forEach((e) => (this.emailslist = this.emailslist + e.Email + ';'));
    } else {
      this.emailslist = '';
      this.checkuncheckflag = true;
    }
    if (counter > 0 && counter <= 10) {
      this.isRequestorAvailabilityDisabled = false;
    } else {
      this.isRequestorAvailabilityDisabled = true;
    }
  }

  onRequestAvailability() {
    const a = document.createElement('a');
    const subject = 'Request to Facilitate a Business Chemistry Session';
    const emailBody =
      'Hello Business Chemistry Facilitator(s),%0D%0A%0D%0AYou have been identified as a top match for an upcoming Business Chemistry <Enter Business Chemistry Fundamentals or Business Chemistry 2.0 and add topic name (e.g., Trust Fall)> session for, <Enter Session Name> which will be taking place on <Enter Session Date> at <Enter Session Time> in <Enter City>, <Enter State>.%0D%0APlease respond to this email to let us know of your availability (available / not available) as soon as possible.%0D%0A%0D%0ARegards,%0D%0A<Enter Your Name>';
    let emails = this.emailslist;
    if (this.emailListAcrossPages && this.emailListAcrossPages.length > 0) {
      const emailArray = [];

      this.emailListAcrossPages.map((data) => {
        data.emailslist.map((email) => {
          emailArray.push(email);
        });
      });

      emails = emailArray.join(';');
    }
    a.href =
      'mailto:' + emails + '?subject=' + subject + '&body=' + emailBody + '';
    a.click();
  }

  getTabChange() {
    const presenter = {
      selectedName: this.selectedName,
      selectedCountry: this.selectedCountry,
      selectedState: this.selectedState,
      selectedCity: this.selectedCity,
      selectedFunction: this.selectedFunction,
      selectedService: this.selectedService,
      selectedJobLevel: this.selectedJobLevel,
      selectedIndustry: this.selectedIndustry,
      selectedSector: this.selectedSector,
      selectedCertificationLevel: Number(this.selectedCertificationLevel),
      selectedExperienceLevelRange: this.selectedExperienceLevelRange,
      pageNo: this.pageNoToSave,
      sortColumn: this.sortColumn,
      sortOrder: this.sortOrder,
      emailListAcrossPages: this.emailListAcrossPages,

      selectedDeliveryModel: this.selectedDeliveryModel,
      userType: this.userType,
      contentArea: this.selectedContentArea,
      topic: this.selectedTopic ?? 0,
    };

    if (
      this.emailListAcrossPages &&
      this.emailListAcrossPages.length > 0 &&
      !this.disableButtons
    ) {
      presenter.emailListAcrossPages = this.emailListAcrossPages;
    } else if (this.emailslist && !this.disableButtons) {
      const emaillist = this.emailslist.split(';');
      const emailArrayList = [
        {
          page: this.previousPage,
          emailslist: emaillist,
          currentPage: this.previousPage,
        },
      ];
      presenter.emailListAcrossPages = emailArrayList;
    } else {
      presenter.emailListAcrossPages = [];
    }
    this.masterDataService.facilitatorData = presenter;
  }

  reloadWithData() {
    const facilitatorData = this.masterDataService.facilitatorData;

    if (facilitatorData) {
      this.userType = facilitatorData.userType
        ? facilitatorData.userType
        : null;
      this.selectedTopic = facilitatorData.topic ?? 0;
      this.selectedContentArea = facilitatorData.contentArea
        ? facilitatorData.contentArea
        : null;
      this.selectedName = facilitatorData.selectedName
        ? facilitatorData.selectedName
        : '';

      facilitatorData.selectedCountry.forEach((item, index) => {
        const filtered_country = this.countryList.filter(
          (data) => data.ID === Number(item)
        );
        this.selectedCountry.push(filtered_country[0]);
      });
      facilitatorData.selectedState.forEach((item, index) => {
        const filtered_state = this.stateList.filter(
          (data) => data.ID === Number(item)
        );
        this.selectedState.push(filtered_state[0]);
      });

      facilitatorData.selectedCity.forEach((item, index) => {
        const filtered_city = this.cityList.filter(
          (data) => data.CityID === Number(item)
        );
        this.selectedCity.push(filtered_city[0]);
      });

      facilitatorData.selectedFunction.forEach((item, index) => {
        const filtered_function = this.functionList.filter(
          (data) => data.ID === Number(item)
        );
        this.selectedFunction.push(filtered_function[0]);
      });

      facilitatorData.selectedService.forEach((item, index) => {
        const filtered_service = this.serviceList.filter(
          (data) => data.ServiceAreaID === Number(item)
        );
        this.selectedService.push(filtered_service[0]);
      });

      facilitatorData.selectedJobLevel.forEach((item, index) => {
        const filtered_jobLevel = this.jobLevelList.filter(
          (data) => data.ID === Number(item)
        );
        this.selectedJobLevel.push(filtered_jobLevel[0]);
      });

      facilitatorData.selectedIndustry.forEach((item, index) => {
        const filtered_Industry = this.industryList.filter(
          (data) => data.ID === Number(item)
        );
        this.selectedIndustry.push(filtered_Industry[0]);
      });

      facilitatorData.selectedSector.forEach((item, index) => {
        const filtered_sector = this.sectorList.filter(
          (data) => data.SectorID === Number(item)
        );
        this.selectedSector.push(filtered_sector[0]);
      });
      this.selectedCertificationLevel =
        facilitatorData.selectedCertificationLevel
          ? facilitatorData.selectedCertificationLevel
          : 0;

      facilitatorData.selectedExperienceLevelRange.forEach((item, index) => {
        const filtered_selectedLevel = this.experinceLevelRange.filter(
          (data) => data.SessionsRange === item
        );

        this.selectedExperienceLevelRange.push(filtered_selectedLevel[0]);
      });

      facilitatorData.selectedDeliveryModel.forEach((item, index) => {
        const filtered_selectedDeliveryModel = this.deliveryModelList.filter(
          (data) => data.SessionFormatID === Number(item)
        );
        this.selectedDeliveryModel.push(filtered_selectedDeliveryModel[0]);
      });

      if (
        this.selectedName !== '' ||
        this.selectedCountry.length !== 0 ||
        this.selectedState.length !== 0 ||
        this.selectedCity.length !== 0 ||
        this.selectedFunction.length !== 0 ||
        this.selectedService.length !== 0 ||
        this.selectedJobLevel.length !== 0 ||
        this.selectedIndustry.length !== 0 ||
        this.selectedSector.length !== 0 ||
        this.selectedCertificationLevel !== 0 ||
        this.selectedExperienceLevelRange.length !== 0 ||
        this.selectedDeliveryModel.length !== 0 ||
        this.userType !== null ||
        this.selectedContentArea !== null ||
        this.selectedTopic !== null ||
        this.selectedTopic !== 0
      ) {
        this.onSearch(1, 'LastName', 'ASC', true);
      }
    }
  }

  checkDisability() {
    this.disableButtons = false;
  }

  reloadByQueryParams() {
    const _this = this;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && Object.keys(params).length > 0) {
        _this.reloadUsingQueryParams = true;

        _this.selectedCountry = _this.countryList.filter(
          (data) => data.ID == params['country']
        );
        this.disableState = _this.selectedCountry.length > 0 ? false : true;
        _this.countryPlaceholder = _this.selectedCountry[0]?.Name;
        _this.selectedState = _this.stateList.filter(
          (data) => data.ID == params['state']
        );
        _this.statePlaceholder = _this.selectedState[0]?.Name;
        _this.selectedCity = _this.cityList.filter(
          (data) => data.CityID == params['city']
        );
        _this.cityPlaceholder = _this.selectedCity[0]?.CityName;
        _this.selectedCertificationLevel = Number(params['level']);

        _this.selectedContentArea = Number(params['contenArea'] ?? 0);
        _this.selectedTopic = Number(params['topic'] ?? 0);

        if (_this.selectedCertificationLevel === 2) {
          _this.selectedContentArea = 0;
          _this.selectedTopic = 0;
        }
        _this.checkDisability();
      }
    });
    this.showLoader = false;
  }

  onUserTypeChange(value: string): void {
    if (value !== null && value !== 'null') {
      this.selectedCertificationLevel = value === 'Yes' ? 1 : 2;
    } else {
      this.selectedCertificationLevel = 0;
    }
  }

  ScrollIntoView(elem: string): void {
    setTimeout(() => {
      document
        .querySelector(elem)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  onExportClick(): void {
    this.facilitatorService
      .getExportData(this.exportPayload)
      .subscribe((res) => {
        const binaryData = [];
        binaryData.push(res);
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/vnd.ms-excel' })
        );
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.href = url;
        a.download = 'Facilitator_Report.xls';
        a.click();
      });
  }
  ngOnDestroy() {
    this.masterDataService.facilitatorData = null;
  }
}
